module.exports = __webpack_public_path__ + "img/wanzi.c2934233.jpg";